import { Navigate } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useAuth } from '@/lib/auth-store';

/**
 * Route-level gate. Unauthorised users are bounced to /dashboard rather than
 * shown a forbidden screen — they simply don't have this surface.
 */
export function RequireRole({ allow, children }: { allow: readonly string[]; children: ReactNode }) {
  const user = useAuth((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (!allow.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
